
import "../Text/Text.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_146_2_TableActionCell";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_146_2_TableActionCell__root","action":"wds_1_146_2_TableActionCell__action","hoverSlot":"wds_1_146_2_TableActionCell__hoverSlot","onHover":"wds_1_146_2_TableActionCell__onHover","notOnHover":"wds_1_146_2_TableActionCell__notOnHover","placeholderIcon":"wds_1_146_2_TableActionCell__placeholderIcon"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




